<template>
  <div>
    <div class="room">
      <div class="room__top">
        <booking
          :room="room"
          :time_format="time_format"
          :current_locale="locale"
          @create="create"
          @change_room_link="change_room_link"
        />
        <div class="room__right">
          <div class="room__info">
            {{ $tr('onlineInterview.room.info') }}
          </div>
          <add-calendar v-if="room_link" :name="room_name" :link="room_link" :date="room_date" />
        </div>
      </div>

      <div class="room__bottom">
        <history :locale="locale" :time_format="time_format" />
      </div>
    </div>
  </div>
</template>

<script>
  import booking from './components/booking.vue';
  import addCalendar from './components/addCalendar.vue';
  import history from './components/history.vue';

  export default {
    name: 'online-interview',

    components: {
      booking,
      addCalendar,
      history
    },

    data() {
      return {
        room_name: $tr('online-interview.name'),
        room_link: '',
        room_date: ''
      };
    },

    created() {
      this.load();
    },

    computed: {
      room() {
        return this.$store.getters['online_interview/room'];
      },

      company() {
        return this.$store.getters['user/company'];
      },

      time_format() {
        return this.company ? this.company.time_format : 24;
      },

      locale() {
        return this.$store.getters['locale/current'];
      }
    },

    methods: {
      load() {
        this.$store.dispatch('online_interview/load');
      },

      create(params) {
        this.$store
          .dispatch('online_interview/create', {
            date_start: params.date_start,
            name: params.name
          })
          .then(() => {
            this.load();
            this.room_name = params.name;
            this.room_date = params.date_start;
          });
      },

      change_room_link(val) {
        this.room_link = val;
      }
    },

    beforeDestroy() {
      this.$store.dispatch('online_interview/clear');
    }
  };
</script>

<style lang="scss" scoped>
  .room {
    padding: 30px 60px 30px 30px;
    position: relative;
    min-height: calc(100vh - 131px);
    box-sizing: border-box;

    &__top {
      display: flex;
      align-items: stretch;
    }
  }

  .room__right {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    padding-left: 110px;
  }

  .room__info {
    padding: 14px 18px;
    width: 316px;
    background: #f9f9f9;
    border-radius: 2px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #233346;
    box-sizing: border-box;
  }
</style>
